export default __webpack_public_path__ + "static/media/equipment-maintenance.08e88553.svg";